export const TYPES = {
    GET_USER_DATA: "GET_USER_DATA",
    GET_USER_DATA_LOADING: "GET_USER_DATA_LOADING",
    GET_USER_DATA_FAILED: "GET_USER_DATA_FAILED",
    USER_SUPER_ADMIN: "USER_SUPER_ADMIN"
}
